
import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class ConfirmModal extends Vue {
  clickSubmit(): void {
    this.$emit('submit');
  }

  clickCancel(): void {
    this.$emit('cancel');
  }
}
